<template>
  <div>
    <v-navigation-drawer
      :value="isAddNewTipoSolicitacaoSidebarActive"
      temporary
      touchless
      :right="!$vuetify.rtl"
      :width="$vuetify.breakpoint.smAndUp ? 350 : '100%'"
      app
      @input="(val) => $emit('update:is-add-new-tipo-solicitacao-sidebar-active', val)"
    >
      <v-card height="100%">
        <div class="drawer-header d-flex align-center mb-4">
          <span class="font-weight-semibold text-base text--primary">Adicionar Tipo de Solicitação</span>
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="$emit('update:is-add-new-tipo-solicitacao-sidebar-active', false)"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </div>

        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
            @submit.prevent="onSubmit"
          >
            <v-text-field
              v-model="tipoSolicitacaoData.nome"
              outlined
              dense
              :rules="[validators.required]"
              label="Nome"
              placeholder="Nome"
              hide-details="auto"
              class="mb-6"
            />

            <v-textarea
              v-model="tipoSolicitacaoData.descricao"
              outlined
              dense
              auto-grow
              label="Descrição"
              placeholder="Descrição"
              hide-details="auto"
              class="mb-6"
            />

            <v-btn
              color="primary"
              class="me-3 mb-1"
              type="submit"
            >
              <v-progress-circular
                v-if="loadings"
                class="mx-6"
                indeterminate
                color="secundary"
              ></v-progress-circular>
              <span v-else> Adicionar </span>
            </v-btn>
            <v-btn
              color="secondary"
              class="mb-1"
              outlined
              type="reset"
              @click="resetTipoSolicitacaoData"
            >
              Cancelar
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-navigation-drawer>
  </div>
</template>

<script>
import {
  emailValidator, nameValidator, passwordValidator,
  required,
  select,
} from '@core/utils/validation'
import { mdiClose, mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js'
import { ref } from '@vue/composition-api'
import { isTelefoneCelularValido, isCpfValido } from '@/utils/validation'
import TipoSolicitacaoService from '@/services/modules/TipoSolicitacaoService'

export default {
  model: {
    prop: 'isAddNewTipoSolicitacaoSidebarActive',
    event: 'update:is-add-new-tipo-solicitacao-sidebar-active',
  },
  props: {
    isAddNewTipoSolicitacaoSidebarActive: {
      type: Boolean,
      required: true,
    },
  },

  data: () => ({
    loading: true,
  }),

  setup(props, { emit }) {
    const blankTipoSolicitacaoData = {
      nome: '',
      descricao: '',
      filaId: null,
    }

    const valid = ref(false)
    const form = ref(null)

    const loadings = ref(false)

    const validate = () => {
      form.value.validate()
    }

    const resetForm = () => {
      form.value.reset()
    }

    const tipoSolicitacaoData = ref(JSON.parse(JSON.stringify(blankTipoSolicitacaoData)))

    const resetTipoSolicitacaoData = () => {
      tipoSolicitacaoData.value = JSON.parse(JSON.stringify(blankTipoSolicitacaoData))
      resetForm()
      setTimeout(() => {
        emit('update:is-add-new-tipo-solicitacao-sidebar-active', false)
      }, 1000)
    }

    const onSubmit = async () => {
      loadings.value = !loadings.value

      if (valid.value) {
        try {
          await TipoSolicitacaoService.criar(tipoSolicitacaoData.value)

          loadings.value = !loadings.value
          emit('refetch-data')
          resetTipoSolicitacaoData()
        } catch {
          loadings.value = !loadings.value
        }
      } else {
        loadings.value = !loadings.value
        validate()
      }
    }

    return {
      resetTipoSolicitacaoData,
      onSubmit,
      validate,
      form,
      tipoSolicitacaoData,
      valid,
      blankTipoSolicitacaoData,
      loadings,
      validators: {
        required,
        emailValidator,
        select,
        nameValidator,
        isCpfValido,
        passwordValidator,
        isTelefoneCelularValido,
      },
      icons: {
        mdiClose,
        mdiEyeOffOutline,
        mdiEyeOutline,
      },
    }
  },
}
</script>
